(function(){
  // URL of the deployed chat worker (js/worker.js). Set it after `wrangler deploy`, e.g.
  // 'https://bwstays-chat-worker.<your-account-subdomain>.workers.dev/chat'. It can also be
  // supplied as window.BWSTAYS_CHAT_ENDPOINT. While empty, the chat answers from the local
  // knowledge base only.
  const CHAT_ENDPOINT = (typeof window !== 'undefined' && window.BWSTAYS_CHAT_ENDPOINT) || '';
  let knowledgeBase = [];
  let knowledgeLoaded = false;
  async function loadKnowledgeBase() {
    if (knowledgeLoaded) return;
    try {
      const response = await fetch('/llms-full.txt');
      if (!response.ok) throw new Error('Failed to load knowledge base');
      const text = await response.text();
      const chunks = [];
      const sections = text.split(/(?=##\s)|(?=###\s)|(?=####\s)|(?=#####\s)/);
      sections.forEach((section, index) => {
        if (section.trim().length < 50) return;
        const paragraphs = section.split(/\n\s*\n/);
        paragraphs.forEach(paragraph => {
          const cleanParagraph = paragraph.trim();
          if (cleanParagraph.length > 30) {
            const keyTerms = extractKeyTerms(cleanParagraph);
            chunks.push({
              content: cleanParagraph,
              keywords: keyTerms,
              section: index
            });
          }
        });
      });
      knowledgeBase = chunks;
      knowledgeLoaded = true;
    } catch (error) {
    }
  }
  function extractKeyTerms(text) {
    const terms = new Set();
    const cleanText = text.toLowerCase();
    const bwTerms = ['bwstays', 'bw stays', 'black and white stays'];
    bwTerms.forEach(term => {
      if (cleanText.includes(term)) terms.add(term);
    });
    const locations = ['wayanad', 'kalpetta', 'vythiri', 'lakkidi', 'sultan bathery', 'mananthavady'];
    locations.forEach(loc => {
      if (cleanText.includes(loc)) terms.add(loc);
    });
    const categories = ['waterfall', 'temple', 'dam', 'lake', 'wildlife', 'plantation', 'museum', 'heritage', 'romantic', 'trekking', 'trucking', 'cycling', 'bamboo', 'rafting', 'food', 'restaurant','stays'];
    categories.forEach(cat => {
      if (cleanText.includes(cat)) terms.add(cat);
    });
    const accommodation = ['villa', 'homestay','hotel', 'resort', 'stay', 'booking', 'room', 'amenities', 'check-in', 'checkout'];
    accommodation.forEach(acc => {
      if (cleanText.includes(acc)) terms.add(acc);
    });
    return Array.from(terms);
  }
  function detectPopularAttraction(text) {
    const cleanText = text.toLowerCase();
    const popularPlaces = [
      { name: '900 Kandi', aliases: ['900 kandi', 'thollayiram kandi', 'glass bridge'] },
      { name: 'Pookode Lake', aliases: ['pookode', 'pookode lake'] },
      { name: 'Lakkidi View Point', aliases: ['lakkidi', 'lakkidi ghats', 'lakkidi viewpoint'] },
      { name: 'Chembra Peak', aliases: ['chembra', 'chembra peak', 'chembra trek'] },
      { name: 'Edakkal Caves', aliases: ['edakkal', 'edakkal caves', 'cave'] },
      { name: 'Banasura Dam', aliases: ['banasura', 'banasurasagar', 'banasura dam'] },
      { name: 'Soochipara Falls', aliases: ['soochipara', 'sentinel rock'] },
      { name: 'Meenmutty Falls', aliases: ['meenmutty', 'meenmutty falls'] }
    ];
    for (const place of popularPlaces) {
      if (place.aliases.some(alias => cleanText.includes(alias))) {
        return place.name;
      }
    }
    return null;
  }
  function getLocalInsights(placeName) {
    const insights = {
      '900 Kandi': {
        googleNote: "This glass bridge attraction is well-documented online.",
        localTips: "Best visited early morning (9-11 AM) to avoid crowds. The mandatory ₹1200 jeep ride from the base is shared. Combine with nearby Soochipara Falls (15 mins away) for a full day."
      },
      'Pookode Lake': {
        googleNote: "A popular freshwater lake with widespread coverage on travel sites.",
        localTips: "Boating available 9 AM-5 PM. Weekday mornings are less crowded. Walking trail around the lake takes 30-45 minutes. Combine with nearby Lakkidi View Point (10 km)."
      },
      'Lakkidi View Point': {
        googleNote: "Known as the 'Gateway to Wayanad' with extensive online information.",
        localTips: "Clear valley views best in early morning (6-8 AM) before mist sets in. Free entry. Combine with Chain Tree (2 km) and Pookode Lake (10 km) in same trip."
      },
      'Chembra Peak': {
        googleNote: "Wayanad's highest peak with detailed trekking guides available online.",
        localTips: "Trek permits required (₹300-500). Start by 6 AM to complete before afternoon heat. Heart-shaped lake at halfway point. Book guides at forest office."
      },
      'Edakkal Caves': {
        googleNote: "Famous prehistoric caves with extensive archaeological information online.",
        localTips: "Open 9:30 AM-4:30 PM. Moderate 45-min climb to caves. Carry water. Best lighting for cave paintings: 10 AM-2 PM. Closed Mondays."
      },
      'Banasura Dam': {
        googleNote: "India's largest earthen dam with comprehensive travel information available.",
        localTips: "Speed boat rides ₹200-300 per person. Best views from the walkway. Sunset timing (5:30-6:30 PM) offers great photography. Less crowded on weekdays."
      },
      'Soochipara Falls': {
        googleNote: "A three-tiered waterfall well-covered in travel blogs.",
        localTips: "1 km trek from parking. Swimming allowed in natural pool (exercise caution). Best flow during monsoon and post-monsoon (June-Dec). Combine with 900 Kandi nearby."
      },
      'Meenmutty Falls': {
        googleNote: "Wayanad's largest waterfall with extensive online documentation.",
        localTips: "2 km trek through forest. Guide recommended (₹100-200). Best visited during monsoon for full flow. Start early to avoid afternoon heat and crowds."
      }
    };
    return insights[placeName] || null;
  }
  function trimContent(content, maxLen = 500) {
    if (!content || content.length <= maxLen) return content;
    const cutoff = content.lastIndexOf('.', maxLen);
    if (cutoff > maxLen * 0.6) {
      return content.slice(0, cutoff + 1);
    }
    return content.slice(0, maxLen) + '…';
  }
  function searchKnowledgeBase(query, maxChunks = 3) {
    if (!knowledgeLoaded || knowledgeBase.length === 0) return [];
    const queryLower = query.toLowerCase();
    const queryTerms = extractKeyTerms(query);
    const scoredChunks = knowledgeBase.map(chunk => {
      let score = 0;
      if (chunk.content.toLowerCase().includes(queryLower)) {
        score += 10;
      }
      queryTerms.forEach(term => {
        if (chunk.keywords.includes(term)) {
          score += 5;
        }
        if (chunk.content.toLowerCase().includes(term)) {
          score += 3;
        }
      });
      if (chunk.content.length < 500) {
        score += 1;
      }
      return { ...chunk, score };
    });
    return scoredChunks
      .filter(chunk => chunk.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, maxChunks)
      .map(chunk => trimContent(chunk.content));
  }
  function createChatWidget() {
    const chatBtn = document.createElement('button');
    chatBtn.type = 'button';
    chatBtn.className = 'btn btn-primary btn-floating btn-lg';
    chatBtn.id = 'btn-chat';
    chatBtn.setAttribute('aria-label', 'Ask');
    chatBtn.innerHTML = '<i class="fas fa-comments"></i>';
    const chatModal = document.createElement('div');
    chatModal.id = 'chat-modal';
    chatModal.className = 'chat-modal';
    chatModal.innerHTML = `
      <div class="chat-modal-content">
        <div class="chat-header">
          <h5 class="chat-title">
            <i class="fas fa-headset me-2"></i>
            Chat Assistant
          </h5>
          <button type="button" class="chat-close" id="chat-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="chat-body" id="chat-body">
          <div class="chat-message bot-message">
            <div class="message-avatar">
              <i class="fas fa-headset"></i>
            </div>
            <div class="message-content">
              Hello! I'm your travel assistant for Wayanad. How can I help you today?
            </div>
          </div>
        </div>
        <div class="chat-footer">
          <div class="chat-input-container">
            <input type="text" id="chat-input" placeholder="Type your message or click mic to speak..." maxlength="500">
            <button type="button" id="voice-mic" class="voice-btn" title="Click to speak">
              <i class="fas fa-microphone"></i>
            </button>
            <button type="button" id="voice-speaker" class="voice-btn" title="Listen to responses">
              <i class="fas fa-volume-up"></i>
            </button>
            <button type="button" id="chat-send" disabled>
              <i class="fas fa-paper-plane"></i>
            </button>
          </div>
          <div class="chat-typing" id="chat-typing" style="display: none;">
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span>Assistant is typing...</span>
          </div>
          <div class="voice-status" id="voice-status" style="display: none;">
            <div class="voice-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span id="voice-status-text">Listening...</span>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(chatBtn);
    document.body.appendChild(chatModal);
    return {
      chatBtn: chatBtn,
      chatModal: chatModal,
      chatClose: document.getElementById('chat-close'),
      chatBody: document.getElementById('chat-body'),
      chatInput: document.getElementById('chat-input'),
      chatSend: document.getElementById('chat-send'),
      typingEl: document.getElementById('chat-typing'),
      voiceMic: document.getElementById('voice-mic'),
      voiceSpeaker: document.getElementById('voice-speaker'),
      voiceStatus: document.getElementById('voice-status'),
      voiceStatusText: document.getElementById('voice-status-text')
    };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChat);
  } else {
    initChat();
  }
  function initChat() {
    const elements = createChatWidget();
    const { chatBtn, chatModal, chatClose, chatBody, chatInput, chatSend, typingEl, voiceMic, voiceSpeaker, voiceStatus, voiceStatusText } = elements;
    if(!chatBtn || !chatModal) return;
    // the 900 KB knowledge file is only fetched when the visitor opens the chat
    chatBtn.addEventListener('click', function () { loadKnowledgeBase(); }, { once: true });

    // Voice recognition setup
    let recognition = null;
    let isListening = false;
    let speechSynthesis = window.speechSynthesis;
    let isSpeaking = false;
    let autoSpeakEnabled = false;

    // Initialize speech recognition if available
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      recognition = new SpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = 'en-US';

      recognition.onstart = function() {
        isListening = true;
        voiceMic.classList.add('listening');
        voiceStatus.style.display = 'flex';
        voiceStatusText.textContent = 'Listening...';
        voiceMic.innerHTML = '<i class="fas fa-microphone-slash"></i>';
        voiceMic.title = 'Click to stop listening';
      };

      recognition.onresult = function(event) {
        const transcript = event.results[0][0].transcript;
        chatInput.value = transcript;
        chatInput.dispatchEvent(new Event('input'));
        if (transcript.trim()) {
          setTimeout(() => handleSend(), 500);
        }
      };

      recognition.onerror = function(event) {
        console.error('Speech recognition error:', event.error);
        stopListening();
        if (event.error === 'not-allowed') {
          alert('Microphone access denied. Please allow microphone access to use voice input.');
        }
      };

      recognition.onend = function() {
        stopListening();
      };
    } else {
      voiceMic.style.display = 'none';
      console.warn('Speech recognition not supported in this browser');
    }

    function startListening() {
      if (recognition && !isListening) {
        try {
          recognition.start();
        } catch (error) {
          console.error('Error starting speech recognition:', error);
        }
      }
    }

    function stopListening() {
      isListening = false;
      voiceMic.classList.remove('listening');
      voiceStatus.style.display = 'none';
      voiceMic.innerHTML = '<i class="fas fa-microphone"></i>';
      voiceMic.title = 'Click to speak';
      if (recognition) {
        recognition.stop();
      }
    }

    function speakText(text) {
      if (!speechSynthesis) return;

      // Stop any ongoing speech
      speechSynthesis.cancel();

      const utterance = new SpeechSynthesisUtterance(text);
      utterance.rate = 0.9;
      utterance.pitch = 1;
      utterance.volume = 0.8;

      utterance.onstart = function() {
        isSpeaking = true;
        voiceSpeaker.classList.add('speaking');
        voiceSpeaker.innerHTML = '<i class="fas fa-volume-mute"></i>';
        voiceSpeaker.title = 'Click to stop speaking';
      };

      utterance.onend = function() {
        isSpeaking = false;
        voiceSpeaker.classList.remove('speaking');
        voiceSpeaker.innerHTML = '<i class="fas fa-volume-up"></i>';
        voiceSpeaker.title = 'Listen to responses';
      };

      utterance.onerror = function(event) {
        console.error('Speech synthesis error:', event.error);
        isSpeaking = false;
        voiceSpeaker.classList.remove('speaking');
        voiceSpeaker.innerHTML = '<i class="fas fa-volume-up"></i>';
        voiceSpeaker.title = 'Listen to responses';
      };

      speechSynthesis.speak(utterance);
    }

    function stopSpeaking() {
      if (speechSynthesis) {
        speechSynthesis.cancel();
        isSpeaking = false;
        voiceSpeaker.classList.remove('speaking');
        voiceSpeaker.innerHTML = '<i class="fas fa-volume-up"></i>';
        voiceSpeaker.title = 'Listen to responses';
      }
    }

    // Voice control event listeners
    if (voiceMic) {
      voiceMic.addEventListener('click', function() {
        if (isListening) {
          stopListening();
        } else {
          startListening();
        }
      });
    }

    if (voiceSpeaker) {
      voiceSpeaker.addEventListener('click', function() {
        if (isSpeaking) {
          stopSpeaking();
        } else {
          autoSpeakEnabled = !autoSpeakEnabled;
          voiceSpeaker.classList.toggle('auto-speak', autoSpeakEnabled);
          if (autoSpeakEnabled) {
            voiceSpeaker.title = 'Auto-speak enabled (click to disable)';
          } else {
            voiceSpeaker.title = 'Listen to responses';
          }
        }
      });
    }
    function toggleModal(forceOpen){
      const shouldOpen = forceOpen !== undefined ? forceOpen : !chatModal.classList.contains('open');
      if(shouldOpen){
        chatModal.classList.add('open');
        document.body.dataset.prevOverflow = document.body.style.overflow || '';
        document.body.style.overflow = 'hidden';
        setTimeout(()=> chatInput?.focus(), 50);
      } else {
        chatModal.classList.remove('open');
        document.body.style.overflow = document.body.dataset.prevOverflow || '';
        delete document.body.dataset.prevOverflow;
      }
    }
    chatBtn.addEventListener('click', ()=> toggleModal(true));
    chatClose.addEventListener('click', ()=> toggleModal(false));
    chatInput.addEventListener('input', ()=>{
      const hasText = chatInput.value.trim().length > 0;
      chatSend.disabled = !hasText;
    });
    function appendMessage(role, text){
      const msg = document.createElement('div');
      msg.className = `chat-message ${role === 'user' ? 'user-message' : 'bot-message'}`;
      const avatar = document.createElement('div');
      avatar.className = 'message-avatar';
      avatar.innerHTML = role === 'user' ? '<i class="fas fa-user"></i>' : '<i class="fas fa-headset"></i>';
      const content = document.createElement('div');
      content.className = 'message-content';
      content.textContent = text;

      // Add speaker button for bot messages
      if (role === 'assistant' || role === 'bot') {
        const speakBtn = document.createElement('button');
        speakBtn.className = 'message-speak-btn';
        speakBtn.innerHTML = '<i class="fas fa-volume-up"></i>';
        speakBtn.title = 'Listen to this message';
        speakBtn.addEventListener('click', function() {
          if (isSpeaking) {
            stopSpeaking();
          } else {
            speakText(text);
          }
        });
        content.appendChild(speakBtn);

        // Auto-speak if enabled
        if (autoSpeakEnabled && !isSpeaking) {
          setTimeout(() => speakText(text), 500);
        }
      }

      msg.appendChild(avatar);
      msg.appendChild(content);
      chatBody.appendChild(msg);
      chatBody.scrollTop = chatBody.scrollHeight;
    }
    function isOnTopic(text){
      const t = (text || '').toLowerCase();
      const keywords = [
        'bwstays', 'bw stays', 'wayanad', 'kalpetta', 'vythiri', 'lakkidi', 'sultan bathery', 'mananthavady',
        'villa', 'resort', 'homestay', 'stay', 'booking', 'reservation', 'check-in', 'check out', 'checkin', 'checkout',
        'attraction', 'things to do', 'trek', 'waterfall', 'dam', 'lake', 'temple', 'wildlife', 'sanctuary',
        'amenities', 'pool', 'wifi', 'breakfast', 'parking', 'pet friendly', 'ac', 'air conditioning',
        'price', 'prices', 'rate', 'rates', 'cost', 'availability', 'rooms', 'room', 'night', 'per night',
        'cancellation', 'refund', 'policy', 'policies', 'terms', 'check-in time', 'check-out time',
        'contact', 'phone', 'whatsapp', 'email', 'support', 'customer care','location', 'address', 'map', 'directions', 'near', 'nearby', 'distance', 'airport', 'railway', 'bus','season', 'weather', 'monsoon', 'summer','winter','place','places','discover','natural','modern','greenery','location','food','resturant','valleys','kerala','hills','hill','mountain','stays','contact','tour','tourist','vacation','weekend','homestay','staycation','workation','estate','plantation','coffee','tea','kitchen','service','gourmet','romantic','swim','swimming','sports','trucking',
        , 'dam', 'plantation', 'museum', 'heritage', 'romantic', 'trekking',  'cycling', 'bamboo', 'rafting',  'restaurant'];
      return keywords.some(k => t.includes(k));
    }
    function localFallbackAnswer(userText){
      const t = (userText || '').toLowerCase();
      const wantsStay = t.includes('stay') || t.includes('room') || t.includes('villa') || t.includes('homestay') || t.includes('resort');
      const wantsPrice = t.includes('price') || t.includes('rate') || t.includes('cost');
      const wantsAvail = t.includes('availability') || t.includes('available') || t.includes('date');
      const wantsCancel = t.includes('cancel') || t.includes('refund');
      const wantsCheckin = t.includes('check-in') || t.includes('checkin') || t.includes('check out') || t.includes('checkout');
      const wantsAttractions = t.includes('attraction') || t.includes('things to do') || t.includes('waterfall') || t.includes('trek') || t.includes('temple');
      const parts = [];
      const popularPlace = detectPopularAttraction(userText);
      if (popularPlace && wantsAttractions) {
        const insights = getLocalInsights(popularPlace);
        if (insights) {
          parts.push(`Quick note about ${popularPlace}: ${insights.googleNote} Here are our local tips: ${insights.localTips}`);
        }
      } else if (wantsAttractions) {
        parts.push('Many popular Wayanad attractions have general info easily found on Google. We focus on local timing tips, crowd avoidance, and how to combine nearby spots for the perfect day out!');
      }
      if(wantsStay){
        parts.push('For comfortable stays in Wayanad, our villa stay is the perfect base for your Wayanad adventures; the villa takes up to 4 adults and 4 children.');
        parts.push('- Villa stay, photos and amenities: https://www.bwstays.com/bwstays-booking.html#selectvilla');
      }
      if(wantsAvail || wantsPrice){
        parts.push('For real-time prices and availability, visit our booking page: https://www.bwstays.com/bwstays-booking.html');
      }
      if(wantsCancel){
        parts.push('Cancellations: 15 or more days before check-in is a full refund (less payment charges), 7 to 14 days before is 50%, and under 7 days or no-show is no refund. Holiday and peak-season stays need 30 days for a full refund and 15 days for 50%. Full policy: https://www.bwstays.com/footer.html#cancellation');
      }
      if(wantsCheckin){
        parts.push('Check-in is from 2 PM and check-out is by 11 AM.');
      }
      if(wantsAttractions){
        parts.push('Discover more hidden gems and local favorites in our comprehensive attraction guides throughout the site.');
      }
      if(parts.length === 0){
        parts.push('Our travel assistant isn\'t available right now, but we\'re here to help! Ask us about BWStays accommodations, live availability, attraction tips, or planning your perfect Wayanad getaway.');
      }
      parts.push('Need more assistance? Drop us a message through the Contact section – we love helping plan memorable Wayanad experiences!');
      return parts.join('\n\n');
    }
    async function sendToGroq(messages, userQuery){
      await loadKnowledgeBase();
      const relevantChunks = searchKnowledgeBase(userQuery, 2);
      let enhancedSystemPrompt = messages[0].content;
      if (relevantChunks.length > 0) {
        enhancedSystemPrompt += '\n\nRelevant information from BWStays knowledge base:\n' +
          relevantChunks.map((chunk, i) => `[Context ${i + 1}]: ${chunk}`).join('\n\n');
      }
      const detectedPopular = detectPopularAttraction(userQuery || '');
      if (detectedPopular) {
        enhancedSystemPrompt += `\n\nFor this query about ${detectedPopular}, include a short section titled "Local insights from BWStays" with 2–4 concise bullet points on: best time windows, how to avoid crowds, and smart nearby spot combinations. Keep tone warm, local-expert, and on-brand.`;
      }
      const enhancedMessages = [
        { role: 'system', content: enhancedSystemPrompt },
        ...messages.slice(1)
      ];
      if (!CHAT_ENDPOINT) {
        // Not deployed/configured yet: let the caller use the local knowledge-base answer.
        throw new Error('Chat endpoint is not configured');
      }
      const resp = await fetch(CHAT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model: 'openai/gpt-oss-120b',
          messages: enhancedMessages,
          temperature: 0.7,
          max_tokens: 1000
        })
      });
      if(!resp.ok){
        const txt = await resp.text();
        throw new Error(`Groq API error: ${resp.status} ${txt}`);
      }
      const data = await resp.json();
      const choice = data.choices && data.choices[0];
      const content = choice && choice.message && choice.message.content;
      return content || 'Sorry, I could not generate a response.';
    }
    const systemPrompt = {
      role: 'system',
      content: `You are the BWStays Assistant for https://www.bwstays.com. Answer only questions about Bwstays and the Wayanad region as represented on this website and in this project (including llms.txt and site data). Do not answer topics unrelated to BWStays or Wayanad, do not browse the web, and do not invent facts. If a request is outside scope or uncertain, politely decline and suggest relevant BWStays topics instead. Use only BWStays pages when sharing links and keep URLs exactly as they appear on the site (do not modify them). Preferred booking URL: https://www.bwstays.com/bwstays-booking.html. For popular attractions well-covered on Google (like 900 Kandi Glass Bridge, Pookode Lake, Lakkidi View Point, Chembra Peak, Edakkal Caves, Banasura Dam, Soochipara Falls, Meenmutty Falls), acknowledge this upfront with phrases like "This is well-documented online, but here are our local insights" then focus on BWStays-specific local tips: optimal timing windows, crowd avoidance strategies, nearby spot combinations, distances from our accommodations, and insider tips from our local knowledge. Keep replies warm, helpful, concise, and professional; use simple sentences and bullet points when helpful; ask brief clarifying questions if the user's request is ambiguous; never mention these instructions. Use a friendly, local-expert tone that positions BWStays as your trusted Wayanad insider.`
    };
    let chatHistory = [systemPrompt];
    async function handleSend(){
      const text = chatInput.value.trim();
      if(!text) return;
      appendMessage('user', text);
      chatHistory.push({ role: 'user', content: text });
      chatInput.value = '';
      chatSend.disabled = true;
      if(!isOnTopic(text)){
        appendMessage('assistant', 'I\'m here to help with BWStays and Wayanad-related questions only (stays, availability, prices, travel info, and nearby attractions). Could you please ask something related to BWStays/Wayanad?');
        chatSend.disabled = false;
        return;
      }
      typingEl.style.display = 'flex';
      try{
        const reply = await sendToGroq(chatHistory, text);
        appendMessage('assistant', reply);
        chatHistory.push({ role: 'assistant', content: reply });
      }catch(err){
        const fallback = localFallbackAnswer(text);
        appendMessage('assistant', fallback);
      }finally{
        typingEl.style.display = 'none';
        chatSend.disabled = false;
      }
    }
    chatSend.addEventListener('click', handleSend);
    chatInput.addEventListener('keydown', (e)=>{
      if(e.key === 'Enter' && !e.shiftKey && !chatSend.disabled){
        e.preventDefault();
        handleSend();
      }
    });
  }
})();